import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 58,
    seconds: 46
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-2 text-3xl md:text-5xl font-bold font-mono text-brand-accent" data-id="element-216">
      <div className="bg-brand-card px-4 py-3 rounded-lg border border-neutral-800 w-20 md:w-28 text-center" data-id="element-217">
        {String(timeLeft.hours).padStart(2, '0')}
        <span className="text-xs md:text-sm block text-neutral-500 font-sans mt-1 uppercase tracking-wider" data-id="element-218">
          hs
        </span>
      </div>
      <span className="text-neutral-600 pb-6" data-id="element-219">:</span>
      <div className="bg-brand-card px-4 py-3 rounded-lg border border-neutral-800 w-20 md:w-28 text-center" data-id="element-220">
        {String(timeLeft.minutes).padStart(2, '0')}
        <span className="text-xs md:text-sm block text-neutral-500 font-sans mt-1 uppercase tracking-wider" data-id="element-221">
          min
        </span>
      </div>
      <span className="text-neutral-600 pb-6" data-id="element-222">:</span>
      <div className="bg-brand-card px-4 py-3 rounded-lg border border-neutral-800 w-20 md:w-28 text-center" data-id="element-223">
        {String(timeLeft.seconds).padStart(2, '0')}
        <span className="text-xs md:text-sm block text-neutral-500 font-sans mt-1 uppercase tracking-wider" data-id="element-224">
          seg
        </span>
      </div>
    </div>;
}